import { InactivateProductDocumentInfo, ProductDocument, ProductInfo, ProductItemInfo, ProductItemPriceInfo, ProductItemPriceRequest, ProductItemsPriceInfo, ProductItemPurchasePriceRequest, ProductPurchasePriceInfo, UpdateProductDocumentStatusRequest, ProductKitCreateObj } from "../redux/slice/product/createProductSlice";
import { ProductPriceByProductRequest, searchParamsInfo, searchParamsProdcutsList } from "../redux/slice/product/productListSlice";
import { PracticeProductInfo, SKUProductAgreementRequest, SearchPracticeProductAgreementRequest, UploadSignedAgreementInfo, bulkInactivateInfo, createMassAgreementRequest, inactivateInfo } from "../redux/slice/productAgreement/createAgreementSlice";
import { InterceptorOption } from "../types/CommonTypes";
import {
    CREATE_PRODUCT_AGREEMENT, CREATE_PRODUCT_URL, DELETE_PRODUCT_AGREEMENT_BY_ID_URL, DELETE_PRODUCT_URL,
    FETCH_PRODUCTLIST_URL, FETCH_PRODUCTS_AGREEMENTS, FETCH_PRODUCTS_BY_USER_ROLE_URL, FETCH_PRODUCTS_PRICE_BY_MAC,
    FETCH_PRODUCT_DETAILS_BY_ID, FETCH_PRODUCT_WITH_PRICE_URL, GET_PRODUCT_ITEM_HISTORY_URL, GET_PRODUCT_LIST_WITH_LOGO_URL,
    GET_PRODUCT_PRICE_ITEM_HISTORY_URL, INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL, INACTIVE_PRODUCT_ITEM_URL, INACTIVE_PRODUCT_PRICE_ITEM_URL,
    MANUFACTURE_SIGN_PRODUCT_AGREEMENT, PRACTICE_SIGN_PRODUCT_AGREEMENT, SAVE_PRODUCT_ITEM_URL, SAVE_PRODUCT_LOGO_URL,
    SAVE_PRODUCT_PRICE_ITEM_URL, UPDATE_PRODUCT_TIER_PRICES_URL, UPDATE_PRODUCT, DELETE_PRODUCT_PRICE_ITEM_URL,
    PREVIEW_PRACTICE_PRODUCT_AGREEMENT,
    INITIATE_PRODUCT_AGREEMENT_URL,
    GENERATE_NEW_AGREEMENTS_FOR_EXPIRED_PRODUCT_PRICE,
    GET_AGREEMENT_COUNT_FOR_EXPIRED_PRODUCT_PRICE,
    FETCH_ALL_PRODUCTS_URL,
    GET_PRODUCT_ITEM_BY_PRODUCT_ID,
    GET_PRODUCT_DOCUMENTS_URL,
    ACTIVE_PRODUCT_ITEM_URL,
    UPLOAD_SIGNED_AGREEMENT_BY_ID,
    FETCH_PRODUCTS_INCLUDING_INACTIVE_BY_USER_ROLE_URL,
    UPLOAD_PRODUCT_DOCUMENT,
    SEARCH_PRODUCTLIST_URL,
    INACTIVE_PRODUCT_DOCUMENT,
    FETCH_PRODUCTS_INCLUDING_INACTIVE_FOR_PRODUCT_SEARCH_URL,
    GET_INACTIVATED_PRODUCT_DOCUMENT,
    ACTIVATE_PRODUCT_DOCUMENT,
    UPDATE_PRODUCT_DOCUMENT_STATUS,
    SAVE_PRODUCT_PRICE_ITEMS_URL,
    GET_PRODUCT_PRICING_BY_PRODUCT_ID_URL,
    DELETE_KIT_ITEM_PRODUCT_BY_ID_URL,
    SAVE_PRODUCT_KIT_URL,
    FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_ID,
    CHECK_ANCILLIARY_AGREEMENTS_BY_PRACTICE_ID_URL,
    GET_PRODUCT_QUESTIONS_BY_PRODUCT,
    CHECK_PRODUCT_AGREEMENTS_BY_PRODUCT_TYPE_BY_PRACTICE_ID_URL,
    BULK_INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL,
    FETCH_SKU_PRODUCTS_AGREEMENTS_LIST,
    GET_SAFEGUARD_QUESTIONS_BY_PRODUCT,
    CREATE_MASS_PRODUCT_AGREEMENT_BY_ID_URL,
    GET_PRODUCT_ITEM_BY_PRODUCT_ITEM_ID_URL,
    GET_PRODUCT_ITEMS_IN_PROVIDER_TEMPLATE_BY_PATIENT_URL,
    GET_PRODUCT_ITEMS_BY_PRODUCT_ID_FOR_ORDER_URL,
    GET_PRODUCT_ITEM_BY_SKU_URL,
    FETCH_ALL_PRODUCTS_BY_USER_ROLE_URL,
    FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_IDS,
    GET_PRODUCTS_HAVE_AGREEGEMENTS_BY_PRACTICE_AND_CATEGORY_URL,
    GET_PRODUCT_CONFIG_TEMPLATE_URL,
    GET_PRODUCT_CONFIG_BY_PRODUCT_URL,
    SAVE_PRODUCT_CONFIG_URL,
    GET_PRODUCT_SHIPPING_CONFIG_BY_PRODUCT_ID_URL,
    SAVE_PRODUCT_SHIPPING_CONFIG_URL,
    GET_PRODUCT_SHIPPING_CONFIG_FOR_ORDER_URL,
    GET_AVAILABLE_DRUG_DOSAGE_BY_PRODUCT_URL,
    SAVE_PRODUCT_PURCHASE_PRICE_URL,
    SAVE_PRODUCT_PURCHASE_PRICE_ITEMS_URL,
    INACTIVE_PRODUCT_PURCHASE_PRICE_URL,
    DELETE_PRODUCT_PURCHASE_PRICE_URL,
    GET_PRODUCT_PURCHASE_PRICE_HISTORY_URL,
    GET_ACTIVE_PRODUCT_PURCHASE_PRICES_URL
} from "./URL";
import { http } from "./http";

// CS-1760 START - Product Config Rule Types
export interface ProductConfigRules {
	    productConfigId?: number;
	    productId: number;
	    configType: string;
	    configCode: string;
	    value: string;
	    // metadata?: Record<string, unknown>;
}

export interface ProductConfigTemplate {
	    [configType: string]: {
	        [configCode: string]: string[];
	    };
}

export interface SaveProductConfigRuleItem {
	    configType: string;
	    configCode: string;
	    value: string;
	    metadata?: Record<string, unknown> | null;
}

export interface SaveProductConfigRequest {
	    productId: number;
	    configRules: SaveProductConfigRuleItem[];
}
// CS-1760 END

export const getProductList = async (searchParams : searchParamsInfo) => {
    let queryParam = "";
    if (searchParams.productName) queryParam += `?productName=${searchParams.productName}&`;
    if (searchParams.inactiveDate) queryParam += `?inactiveDate=${searchParams.inactiveDate}&`;
    const response = await http.get(FETCH_PRODUCTLIST_URL);
    console.log("1")
    return response;
};

export const getProductListWithLogos = async () => {
   const response = await http.get(GET_PRODUCT_LIST_WITH_LOGO_URL);
    return response;
};

export const createProducts = async (product: ProductInfo) => {
    const response = await http.post(CREATE_PRODUCT_URL, product);
    return response;
};

export const saveProductItems = async (productItem: ProductItemInfo) => {
    try{
        const response = await http.post(SAVE_PRODUCT_ITEM_URL, productItem);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const updateProductTierPrices = async (productPriceId: number, tierPrices: Record<string, number>) => {
    try {
        const response = await http.post(UPDATE_PRODUCT_TIER_PRICES_URL, { productPriceId, tierPrices });
        return response;
    } catch (error) {
        throw error;
    }
};

export const saveProductPriceItems = async (productPriceItem: ProductItemsPriceInfo) => {
    try{
        const response = await http.post(SAVE_PRODUCT_PRICE_ITEM_URL, productPriceItem);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const inactivateProductPrices = async (id: number, date: string) => {
    try {
        const response = await http.post(`${INACTIVE_PRODUCT_PRICE_ITEM_URL}/${id}`, null, {
            params: {
                inactiveDate: date
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteProductPrice = async (productPriceId: number) => {
    try {
        const response = await http.post(`${DELETE_PRODUCT_PRICE_ITEM_URL}/${productPriceId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const saveProductPurchasePrice = async (payload: ProductPurchasePriceInfo) => {
    try {
        const response = await http.post(SAVE_PRODUCT_PURCHASE_PRICE_URL, payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const saveProductPurchasePriceItems = async (payload: ProductItemPurchasePriceRequest) => {
    try {
        const response = await http.post(SAVE_PRODUCT_PURCHASE_PRICE_ITEMS_URL, payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const inactivateProductPurchasePrice = async (id: number, date: string) => {
    try {
        const response = await http.post(`${INACTIVE_PRODUCT_PURCHASE_PRICE_URL}/${id}`, null, {
            params: { inactiveDate: date }
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteProductPurchasePrice = async (productPurchasePriceId: number) => {
    try {
        const response = await http.post(`${DELETE_PRODUCT_PURCHASE_PRICE_URL}/${productPurchasePriceId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getProductPurchasePricingHistory = async (productId: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_PURCHASE_PRICE_HISTORY_URL}/?productId=${productId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getActiveProductPurchasePrices = async (productId: number) => {
    try {
        const response = await http.get(`${GET_ACTIVE_PRODUCT_PURCHASE_PRICES_URL}/?productId=${productId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const inactivateProductItems = async (id: number, date: string) => {
    try {
        const response = await http.post(`${INACTIVE_PRODUCT_ITEM_URL}/${id}`, null, {
            params: {
                inactiveDate: date
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export const activateProductItems = async (id: number) => {
    try {
        const response = await http.post(`${ACTIVE_PRODUCT_ITEM_URL}/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getProductItem = async (productId: number) => {
    const response = await http.get(FETCH_PRODUCT_DETAILS_BY_ID,
        {
            params: {
                productId: productId
            }
        }
    );
    return response;
};

export const deleteProductItem = async (productId: number) => {
    let queryParam = "";
    if (productId) queryParam += `?productId=${productId}&inactiveDate=${new Date()}`;
    const response = await http.get(DELETE_PRODUCT_URL);
    return response;
};

export const fetchProductsByUserRole = async (includeProductPrice: boolean) => {
    try{
        const response = await http.get(`${FETCH_PRODUCTS_BY_USER_ROLE_URL}?includeProductPrice=${includeProductPrice}`);
        return response;
    } catch (error) {
        throw error;
        }
};

export const fetchProductsIncludingInactiveByUserRole = async (includeProductPrice: boolean, executedOnly: boolean, headers: Record<string, string>) => {
    try{
        const response = await http.get(`${FETCH_PRODUCTS_INCLUDING_INACTIVE_BY_USER_ROLE_URL}?includeProductPrice=${includeProductPrice}&executedOnly=${executedOnly}`, {
             headers: {...headers}
        });
        return response;
    } catch (error) {
        throw error;
        }
};

// CS-1564 - New api for product search
export const fetchAllProductsByUserRole = async (includeProductPrice: boolean, executedOnly: boolean, headers: Record<string, string>) => {
    try{
        const response = await http.get(`${FETCH_ALL_PRODUCTS_BY_USER_ROLE_URL}?includeProductPrice=${includeProductPrice}&executedOnly=${executedOnly}`, {
            headers: {...headers}
        });
        return response;
    } catch (error) {
        throw error;
        }
};

export const fetchProductsIncludingInactiveByUserRoleSkipLoading = async (includeProductPrice: boolean, executedOnly: boolean, headers: Record<string, string>) => {
    try{
        const response = await http.get(`${FETCH_PRODUCTS_INCLUDING_INACTIVE_BY_USER_ROLE_URL}?includeProductPrice=${includeProductPrice}&executedOnly=${executedOnly}`, {
            headers: {...headers}
        });
        return response;
    } catch (error) {
        throw error;
        }
};

export const getProductsPricingHistory = async (id: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_PRICE_ITEM_HISTORY_URL}/?productId=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getProductItemsHistory = async (id: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_ITEM_HISTORY_URL}/?productId=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const saveProductAgreement = async (agreementData: PracticeProductInfo, interceptorOption?: InterceptorOption) => {
    try {
        const response = await http.post(CREATE_PRODUCT_AGREEMENT, agreementData, undefined, interceptorOption);
        return response;
    }catch(error) {
        throw error;
    }
};

export const getProductPricingByMAC = async (macId: number) => {
    try {
        const response = await http.get(`${FETCH_PRODUCTS_PRICE_BY_MAC}?macId=${macId}`);
        return response;
    }catch(error) {
        throw error;
    }  
};

export const getProductPricing = async () => {
    try {
        const response = await http.get(FETCH_PRODUCT_WITH_PRICE_URL);
        return response;
    }catch(error) {
        throw error;
    }
};

export const getProductAgreementList = async(data: SearchPracticeProductAgreementRequest) => {
    try{
        const response = await http.post(FETCH_PRODUCTS_AGREEMENTS, data);
        return response;
    }catch(error) {
        throw error;
    }
};

export const getSKUProductAgreementList = async(data: SKUProductAgreementRequest) => {
    try{
        const response = await http.post(FETCH_SKU_PRODUCTS_AGREEMENTS_LIST, data);
        return response;
    }catch(error) {
        throw error;
    }
};

export const saveProductsLogo = async(data: Object) => {
    try{
        const response = await http.post(SAVE_PRODUCT_LOGO_URL, data);
        return response;
    }catch(error) {
        throw error;
    }
};

export const updateProducts = async(product: Object) => {
    try{
        const response = await http.post(UPDATE_PRODUCT, product);
        return response;
    }catch(error) {
        throw error;
    }
};

export const signPracticeProductAgreement = async (data: Object) => {
    try {
        const response = await http.post(PRACTICE_SIGN_PRODUCT_AGREEMENT, data);
        return response;
    }catch(error){
        throw error;
    }
};

export const signManufactureProductAgreement = async (data: Object) => {
    try {
        const response = await http.post(MANUFACTURE_SIGN_PRODUCT_AGREEMENT, data);
        return response;
    }catch(error){
        throw error;
    }
};
//CS-1628 
export const deleteProductAgreement = async (id: number , canDeleteAgreement:boolean) => {
    try {
        console.log(id)
        const response = await http.post(`${DELETE_PRODUCT_AGREEMENT_BY_ID_URL}?practiceProductId=${id}&canDeleteAgreement=${canDeleteAgreement}`);
        return response;
    } catch(error){
        throw error;
    }
};

export const inactivateProductAgreement = async (inactiveData: inactivateInfo, interceptorOption: InterceptorOption) => {
    try {
        const response = await http.post(INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL, inactiveData, undefined, interceptorOption);
        return response;
    } catch(error){
        throw error;
    }
};

export const bulkInactivateProductAgreement = async (inactiveData: bulkInactivateInfo, interceptorOption: InterceptorOption) => {
    try {
        const response = await http.post(BULK_INACTIVATE_PRODUCT_AGREEMENT_BY_ID_URL, inactiveData, undefined, interceptorOption);
        return response;
    } catch(error){
        throw error;
    }
};

export const createMassProductAgreement = async (ids: createMassAgreementRequest, interceptorOption: InterceptorOption) => {
    try {
        const response = await http.post(CREATE_MASS_PRODUCT_AGREEMENT_BY_ID_URL, ids, undefined, interceptorOption);
        return response;
    } catch(error){
        throw error;
    }
};

export const previewOnboardAgreement = async (practiceProductId: string | number) => {
    try{
        const response = await http.get(`${PREVIEW_PRACTICE_PRODUCT_AGREEMENT}/${practiceProductId}`);
        return response;
    } catch(error){
        throw error;
    }
};

export const initiateAgreements = async (data: number[]) => {
    try { 
        const response = await http.post(INITIATE_PRODUCT_AGREEMENT_URL, data);
        return response;
    } catch (error){
        throw error;
    }
};

export const agreementCountForExpiredProductPrice = async () => {
    try { 
        const response = await http.get(GET_AGREEMENT_COUNT_FOR_EXPIRED_PRODUCT_PRICE);
        return response;
    } catch (error){
        throw error;
    }
};

export const fetchAllProducts = async (includeProductPrice: boolean) => {
    try {
        const response = await http.get(`${FETCH_ALL_PRODUCTS_URL}?includeProductPrice=${includeProductPrice}`);
        return response;
    } catch (error){
        throw error;
    }
};

export const generateAgreementsForExpiredProductPrice = async () => {
    try {
        const response = await http.get(`${GENERATE_NEW_AGREEMENTS_FOR_EXPIRED_PRODUCT_PRICE}`);
        return response;
    } catch (error){
        throw error;
    }
};

export const getProductItemsByProductId = async (productId: number, onlyActiveRecords: boolean) =>{
    const response = await http.get(`${GET_PRODUCT_ITEM_BY_PRODUCT_ID}?productId=${productId}&onlyActiveRecords=${onlyActiveRecords}`);
    return response;
};

export const getProductItemsByProductIdForOrder = async (productId: number, onlyActiveRecords: boolean) =>{
    const response = await http.get(`${GET_PRODUCT_ITEMS_BY_PRODUCT_ID_FOR_ORDER_URL}?productId=${productId}&onlyActiveRecords=${onlyActiveRecords}`);
    return response;
};

export const getProductDocumentsByProductId = async (productId: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_DOCUMENTS_URL}?productId=${productId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const uploadSignedAgreement = async (data: UploadSignedAgreementInfo) => {
    try { 
        const response = await http.post(UPLOAD_SIGNED_AGREEMENT_BY_ID, data);
        return response;
    } catch (error){
        throw error;
    }
};

export const saveProductDocument = async(data: ProductDocument) => {
    try{
        console.log(data)
        const response = await http.post(UPLOAD_PRODUCT_DOCUMENT, data);
        return response;
    }catch(error) {
        throw error;
    }
};

export const fetchProductList = async (searchParams : searchParamsProdcutsList) => {
    const response = await http.post(SEARCH_PRODUCTLIST_URL,searchParams);
    return response;
};

export const inactivateProductDocument = async(data: InactivateProductDocumentInfo) => {
    try{
        const response = await http.post(INACTIVE_PRODUCT_DOCUMENT, data);
        return response;
    }catch(error) {
        throw error;
    }
};

export const getInactivatedProductDocuments = async(productId: number) => {
    try{
        const response = await http.get(`${GET_INACTIVATED_PRODUCT_DOCUMENT}?productId=${productId}`);
        return response;
    }catch(error) {
        throw error;
    }
};

export const productDocumentActivation = async(activateRequest: UpdateProductDocumentStatusRequest) => {
    try{
        const response = await http.post(ACTIVATE_PRODUCT_DOCUMENT, activateRequest);
        return response;
    }catch(error) {
        throw error;
    }
};

export const fetchProductsIncludingInactiveForProductSearch = async (includeProductPrice: boolean, skipLoader: boolean = false) => {
    try {
        const url = `${FETCH_PRODUCTS_INCLUDING_INACTIVE_FOR_PRODUCT_SEARCH_URL}?includeProductPrice=${includeProductPrice}`;
        const response = skipLoader
            ? await http.get(url, { headers: { "x-skip-loader": "true" } })
            : await http.get(url);
        return response;
    } catch (error) {
        throw error;
    }
};

export const editProductDocumentStatus = async(updateRequest: UpdateProductDocumentStatusRequest) => {
    try{
        const response = await http.post(UPDATE_PRODUCT_DOCUMENT_STATUS, updateRequest);
        return response;
    }catch(error) {
        throw error;
    }
};

export const saveProductsItemsPrices = async (productPriceItem: ProductItemsPriceInfo) => {
    try{
        const response = await http.post(SAVE_PRODUCT_PRICE_ITEMS_URL, productPriceItem);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const productPriceByProductId = async(productPriceByProductRequest: ProductPriceByProductRequest) => {
    try{
        const response = await http.get(`${GET_PRODUCT_PRICING_BY_PRODUCT_ID_URL}?productId=${productPriceByProductRequest.productId}&effectiveDate=${productPriceByProductRequest.effectiveDate}`);
        return response;
    }catch(error) {
        throw error;
    }
};
//collagen kit task cs-715 start here
export const fetchProductKitByProductItemId = async (productItemId: number, headers: Record<string, string>) => {
  try {
    const response = await http.get(FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_ID, {params: { productItemId }, headers: {...headers}});
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchProductKitByProductItemIds = async (productItemIds: number[]) => {
  try {
    const response = await http.get(`${FETCH_PRODUCTKITITEMKIT_PRODUCTITEM_BY_IDS}?productItemIds=${productItemIds}` );
    return response;
  } catch (error) {
    throw error;
  }
};

   export const saveproductkit = async (saveproductkit: ProductKitCreateObj) => {
       try{
           const response = await http.post(SAVE_PRODUCT_KIT_URL,saveproductkit , undefined, {skipErrorPopup: true});
           return response;
       }
       catch(error){
          throw error;
       }
   };


   export const deleterefProductbyproductItemKitItemId = async (id: number) => {
       try {
           const response = await http.post(`${DELETE_KIT_ITEM_PRODUCT_BY_ID_URL}?productItemKitItemId=${id}`);
           return response;
       } catch(error){
           throw error;
       }
   };
   //collagen kit task cs-715 end here

   export const hasAncilliaryAgreements = async (practiceId: number) => {
    try {
        const response = await http.get(`${CHECK_ANCILLIARY_AGREEMENTS_BY_PRACTICE_ID_URL}?practiceId=${practiceId}`);
        return response;
    } catch(error){
        throw error;
    }
};
   export const hasAgreementsBasedOnProductType = async (practiceId: number) => {
    try {
        const response = await http.get(`${CHECK_PRODUCT_AGREEMENTS_BY_PRODUCT_TYPE_BY_PRACTICE_ID_URL}?practiceId=${practiceId}`);
        return response;
    } catch(error){
        throw error;
    }
};

export const getProductQuestionsByProductId = async (productId: number) => {
    try {
        const response = await http.get(`${GET_PRODUCT_QUESTIONS_BY_PRODUCT}?productId=${productId}`);
        return response;
    } catch(error){
        throw error;
    }
};

export const getSafeguardQuestionsByProductId = async (productId: number) => {
    try {
        const response = await http.get(`${GET_SAFEGUARD_QUESTIONS_BY_PRODUCT}?productId=${productId}`);
        return response;
    } catch(error){
        throw error;
    }
};

export const getProductItemByProductItemId = async (productItemId: number) =>{
    const response = await http.get(`${GET_PRODUCT_ITEM_BY_PRODUCT_ITEM_ID_URL}?productItemId=${productItemId}`);
    return response;
};

export const getProductItemBySKU = async (sku: string) =>{
    const response = await http.get(`${GET_PRODUCT_ITEM_BY_SKU_URL}?sku=${sku}`);
    return response;
};

export const productItemsInProviderTemplateByPatient = async (patientId: number) =>{
    const response = await http.get(`${GET_PRODUCT_ITEMS_IN_PROVIDER_TEMPLATE_BY_PATIENT_URL}?patientId=${patientId}`);
    return response;
};

export const findAgreementsByPracticeAndProductCategory = async (practiceId: number, productCategory: string) =>{
    const response = await http.get(`${GET_PRODUCTS_HAVE_AGREEGEMENTS_BY_PRACTICE_AND_CATEGORY_URL}?practiceId=${practiceId}&productCategory=${productCategory}`);
    return response;
};

// CS-1760 START - Product Config Rule
export const getProductConfigTemplate = async () => {
    const response = await http.get(GET_PRODUCT_CONFIG_TEMPLATE_URL);
    return response;
};

export const getProductConfigByProduct = async (productId: number) => {
    const response = await http.get(`${GET_PRODUCT_CONFIG_BY_PRODUCT_URL}?productId=${productId}`);
    return response;
};

export const saveProductConfig = async (data: SaveProductConfigRequest) => {
    const response = await http.post(SAVE_PRODUCT_CONFIG_URL, data);
    return response;
};
// CS-1760 END

// CS-1766 - Fetch product shipping config by product ID
export const getProductShippingConfigByProductId = async (productId: number) => {
    const response = await http.get(`${GET_PRODUCT_SHIPPING_CONFIG_BY_PRODUCT_ID_URL}?productId=${productId}`);
    return response;
};

// CS-1766 - Save product shipping config
export interface SaveProductShippingConfigItem {
    shippingConfigId: number;
    isEnabled: boolean;
    rate?: number; // CS-1758 - Only included when user enters a custom rate
}

export interface SaveProductShippingConfigRequest {
    productId: number;
    configs: SaveProductShippingConfigItem[];
}

export const saveProductShippingConfig = async (data: SaveProductShippingConfigRequest) => {
    const response = await http.post(SAVE_PRODUCT_SHIPPING_CONFIG_URL, data);
    return response;
};

// CS-1766 - Fetch product shipping config for order by product ID
// CS-1997 - Optionally pass practiceId so the backend can zero out rates for
// practices flagged for free shipping.
// CS-1766 - allMethods defaults to false on the API (order placement keeps the product and
// free-shipping restrictions). Order fulfillment passes true to list every active method.
export const getProductShippingConfigForOrder = async (productId: number, practiceId?: number, allMethods?: boolean) => {
    let url = `${GET_PRODUCT_SHIPPING_CONFIG_FOR_ORDER_URL}?productId=${productId}`;
    if (practiceId != null) {
        url += `&practiceId=${practiceId}`;
    }
    if (allMethods) {
        url += `&allMethods=true`;
    }
    const response = await http.get(url);
    return response;
};

// CS-1766 END


export const getAvailableDrugDosabeByProduct = async (productId: number) => {
    try {
        const response = await http.get(`${GET_AVAILABLE_DRUG_DOSAGE_BY_PRODUCT_URL}?productId=${productId}`);
        return response;
    } catch(error){
        throw error;
    }
};
